import { UspType } from "../shared/values";

export interface HomeHeadlineData {
  title: string;
  subtitle: string;
}

export interface BlogHeadlineData {
  title: string;
  subtitle: string;
}

export interface HomeContent {
  headline: HomeHeadlineData;
  blog: BlogHeadlineData;
}

export const HOME_CONTENT: HomeContent = {
  headline: {
    title: "Cases",
    subtitle: "Our team and resources have supported clients across more than 17 industries. Explore a few selected case studies below that best showcase our capabilities."
  },
  blog: {
    title: "Blog",
    subtitle: "Pick our brain on real-world projects and innovations below."
  }
}; 